import axiosInstance from "../utils/axios";

function getBasketsApi(codes?: string[], includePublic?: boolean) {
    const params: { codes?: string[], includePublic?: boolean } = {};

    if(includePublic)
        params.includePublic = includePublic;
    if(codes)
        params.codes = codes;

    return axiosInstance.get(`projects/baskets/v2?currency=USD&fields=maximumAvailableForPurchase&fields=estimatedUnitPrice`, {
        params,
        paramsSerializer: params => {
            return `${codes ? params.codes.map((code: any) => 
                `codes=${code}`).join('&') : ''}${params.includePublic ? `&includePublic=${params.includePublic}` : ''}`
        }
    })
}

function getBasketByIdApi(id: string) {
    return axiosInstance.get(`projects/baskets/v2/${id}?currency=USD&fields=maximumAvailableForPurchase&fields=estimatedUnitPrice`)
}

function getProjectByCodeApi(code: string){
    return axiosInstance.get(`projects/v2/${code}`)
}

function getProjectsApi(
    countryCode?: string | null,
    merchantCode?: string,
    locale?: string,
    filteredOptions?: any,
) {
    let queryArray = [];
    if (locale) queryArray.push("locale=" + locale);
    if (countryCode) queryArray.push("countryCode="+countryCode);
    if (merchantCode) queryArray.push("merchantCode="+merchantCode);
    if (filteredOptions?.regions) queryArray.push("regions="+filteredOptions?.regions);
    if (filteredOptions?.methodCategory) queryArray.push("methodCategories="+filteredOptions?.methodCategory);
    if (filteredOptions?.registry) queryArray.push("registryCodes="+filteredOptions?.registry);
    if (filteredOptions?.projectIds) {
        filteredOptions.projectIds.forEach((id: string) => queryArray.push("projectIds="+id))
    }
    if (filteredOptions?.statuses) {
        filteredOptions.statuses.forEach((s: string) => queryArray.push("statuses="+s))
    }
    // searches all text fields; including highlights
    if (filteredOptions?.searchTerm) queryArray.push("searchTerm="+filteredOptions?.searchTerm);
    let queryString = queryArray.length ? '?'+queryArray.join("&") : "";

    return axiosInstance.get(`projects/v2/${queryString}`)
}

export {
    getBasketsApi,
    getBasketByIdApi,
    getProjectByCodeApi,
    getProjectsApi,
};